import { Button as MuiButton } from '@mui/material';
import React from 'react'

const Button = ({ variant, size, minWidth = 120, sx, ...props }) => (
  <MuiButton
    variant={variant ? variant : 'outlined'}
    size={size ? size : 'large'}
    sx={{
      minWidth: minWidth,
      ...sx,
    }}
    {...props}
  />
);

export default Button;